import React from 'react';

export default function TestAccountsTab({ testUsers, onCleanupExpired, onDeleteUser }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">Testkontoer ({testUsers.length})</h2>
        <button onClick={onCleanupExpired} className="px-4 py-2 bg-orange-600 text-white rounded-lg text-sm font-medium hover:bg-orange-700">
          Rydd opp utløpte
        </button>
      </div>

      {testUsers.length === 0 ? (
        <div className="bg-gray-800 rounded-lg p-8 text-center text-gray-400">
          Ingen testkontoer funnet
        </div>
      ) : (
        <div className="bg-gray-800 rounded-lg divide-y divide-gray-700">
          {testUsers.map(user => (
            <div key={user.id} className="p-4 flex items-center justify-between">
              <div>
                <div className="font-medium flex items-center gap-2">
                  {user.name}
                  {user.is_expired ? (
                    <span className="px-2 py-0.5 bg-red-600 text-xs rounded">UTL&Oslash;PT</span>
                  ) : (
                    <span className="px-2 py-0.5 bg-green-600 text-xs rounded">AKTIV</span>
                  )}
                </div>
                <div className="text-sm text-gray-400">
                  {user.email} &bull; {user.org_name}
                  {user.days_remaining !== null && ` \u2022 ${user.days_remaining} dager igjen`}
                </div>
              </div>
              <button onClick={() => onDeleteUser(user)} className="text-red-400 hover:text-red-300 text-sm">
                Slett
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
